import Vue from 'vue'
import Vuex from 'vuex'

import { store as giscubeStore } from '@giscube/geoportal'

import customLayer from './module-custom-layer'
import basicLayout from './module-basic-layout'
import downloads from './module-downloads'
import infraplan from './module-infraplan'
import openData from './module-open-data'
import panorama from './module-panorama'
import search from './module-search'

Vue.use(Vuex)

const modules = {
  customLayer,
  basicLayout,
  downloads,
  infraplan,
  openData,
  panorama,
  search
}

function registerModules (store) {
  for (let k in modules) {
    if (store.state[k] === undefined) {
      store.registerModule(k, modules[k])
    }
  }
  giscubeStore.registerModules(store)
}

function createStore (/* { ssrContext } */) {
  const store = new Vuex.Store({ modules })
  giscubeStore.registerModules(store)
  window.$store = store
  return store
}

createStore.modules = modules
createStore.registerModules = registerModules

export default createStore
